AgrimarketFactories.factory("parametersFactory", [
	function () {
		return {
			Parameters: null
		};
	}]);